import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import UIList from 'UIComponents/list/UIList';
export default function ReviewActionsWrapper({
  className,
  children
}) {
  return /*#__PURE__*/_jsx(UIList, {
    inline: true,
    use: "inline-divided",
    className: classNames(className, 'm-top-6'),
    children: children
  });
}